import {
  AfterViewInit,
  ChangeDetectorRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  Injector,
  OnDestroy,
  ViewContainerRef,
  inject,
  input,
} from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { FormControl, NgControl } from '@angular/forms';
import { cueClose, IconComponent } from '@cue/ui/icons';

@Directive({
  selector: '[cueClearable]',
  standalone: true,
  host: {
    class: 'has-clear',
  },
})
export class ClearableDirective implements AfterViewInit, OnDestroy {
  private control = inject(NgControl, { optional: true });
  private formControl = inject(FormControl, { optional: true });
  private viewContainer = inject(ViewContainerRef);
  private cdr = inject(ChangeDetectorRef);
  private elRef = inject(ElementRef);
  private factoryComponentResolver = inject(ComponentFactoryResolver);
  private injector = inject(Injector);
  cueClearable = input<boolean>();
  _sub: Subscription;
  _componentRef: ComponentRef<IconComponent> | null = null;

  detachIcon() {
    if (!this._componentRef) {
      return;
    }
    if (this._sub) {
      this._sub.unsubscribe();
    }
    if (this._componentRef) {
      const index = this.viewContainer.indexOf(this._componentRef.hostView);
      this.viewContainer.detach(index);
      this._componentRef.destroy();
      this._componentRef = null;
    }
  }

  attachIcon() {
    if (this._componentRef) {
      return;
    }
    if (!this._componentRef) {
      const factory = this.factoryComponentResolver.resolveComponentFactory(IconComponent);
      this._componentRef = this.viewContainer.createComponent(factory, 0, this.injector);
      (this._componentRef.location.nativeElement as HTMLElement).classList.add('clear');
      this._componentRef.setInput('icon', cueClose);
      this._sub = fromEvent(this._componentRef.location.nativeElement, 'click').subscribe(() => {
        this.clear();
      });
    }
  }

  ngAfterViewInit(): void {
    if (this.cueClearable()) {
      if (!this.control) {
        this.attachIcon();
      } else {
        this.bindControl();
        if (this.control.value?.length > 0) {
          this.attachIcon();
        } else {
          this.detachIcon();
        }
      }
    }
  }

  bindControl() {
    this.control.valueChanges.subscribe((value) => {
      if (value?.length > 0) {
        this.attachIcon();
      } else {
        this.detachIcon();
      }
    });
  }

  clear() {
    if (this.control) {
      this.control.control?.setValue('');
      this.cdr.markForCheck();
    } else {
      this.elRef.nativeElement.value = '';
    }
  }

  ngOnDestroy(): void {
    this._sub?.unsubscribe();
  }
}
